import { cn } from "../util";
import { AlertCircle } from "lucide-react";

interface InvalidTagProps {
  name: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function InvalidTag({ name, size = "md", className }: InvalidTagProps) {
  const sizeClasses = {
    sm: "text-xs px-1.5 py-0.5",
    md: "text-sm px-2 py-1",
    lg: "text-base px-2.5 py-1.5",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md font-medium",
        "bg-red-50 text-red-700 border border-red-200",
        "dark:bg-red-950 dark:text-red-300 dark:border-red-800",
        sizeClasses[size],
        className,
      )}
    >
      <AlertCircle className="w-3 h-3 mr-1 flex-shrink-0" />
      {name}
    </span>
  );
}
